//#region lib/components/FilterRail/criteria/criteria.ts
function e(e, t) {
	return {
		name: e.name,
		...e.qualifier === void 0 ? {} : { qualifier: e.qualifier },
		...e.operator === void 0 || e.operator === t.defaultOperator ? {} : { operator: e.operator }
	};
}
function t(e) {
	return e.reduce((e, t) => e + Math.max(t.values.length, 1), 0);
}
//#endregion
export { e as n, t };

//# sourceMappingURL=criteria-mWYWcOxf.js.map